/**
 * Module dependencies.
 */

import { useRequestProvider } from 'app/components/providers/request-provider/request-provider';
import { resolveAppUrl } from 'app/core/utils/url-resolver';
import { AxiosInstance } from 'axios';
import { useMutation } from '@tanstack/react-query';

/**
 * `Payload` type.
 */

type Payload = {
  userId: string;
  password: string;
};

/**
 * Change Password.
 */

export function changePassword(client: AxiosInstance, payload: Payload): Promise<void> {
  return client
    .post(resolveAppUrl('userChangePassword', { interpolations: { userId: payload.userId } }), {
      password: payload.password
    })
    .then(({ data }) => data);
}

/**
 * Export `usePostChangePassword`.
 */

export function usePostChangePassword() {
  const client = useRequestProvider();

  return useMutation({
    mutationFn: async (payload: Payload) => {
      return await changePassword(client, payload);
    }
  });
}
